export default __webpack_public_path__ + "static/media/transaction.d86fce2e.svg";